module.exports = __webpack_public_path__ + "images/about-us-ready-bg.png";